import type { OnInit } from '@angular/core'
import { ChangeDetectionStrategy, Component, inject, Input, ViewChild } from '@angular/core'
import { FrameComponent } from '@frame'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { timer } from 'rxjs'

import { Required } from '@app/core/decorators/required'
import { ConversationStore } from '@app/modules/messaging/components/store/conversation.store'
import type { Message } from '@app/modules/messaging/models/message.model'
import { ConversationUIService } from '@app/modules/messaging/services/conversation-ui.service'
import { Timespan } from '@app/modules/time/core/timespan.enum'
import { Closeable } from '@app/overlays/closeable'
import { GalleryOverlayPhotoComponent } from '@ui/components/gallery-overlay-photo/gallery-overlay-photo.component'
import { UIModule } from '@ui/ui.module'
import { AsyncPipe } from '@angular/common'
import { Breakpoint2Service } from '@ui/services/breakpoint-2.service'

const TIME_TO_CLOSE = 1 * Timespan.Minute

@UntilDestroy()
@Component({
  selector: 'sb-message-photo-gallery',
  templateUrl: './message-photo-gallery.component.html',
  styleUrls: ['./message-photo-gallery.component.scss'],
  imports: [UIModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoGalleryComponent extends Closeable implements OnInit {
  readonly frameComponent = inject(FrameComponent)
  readonly conversationStore = inject(ConversationStore)
  readonly conversationUIService = inject(ConversationUIService)
  readonly breakpoint2Service = inject(Breakpoint2Service)

  @Required @Input() message!: Message & { type: 'photo'; status: 'viewable' }

  countdown: { createdAt: string; expiresAt: string } | undefined = undefined

  @ViewChild(GalleryOverlayPhotoComponent) galleryOverlayPhotoComponent: GalleryOverlayPhotoComponent | undefined

  ngOnInit(): void {
    if (!this.message.is_me) {
      this.startCountdown()
    }
  }

  private startCountdown(): void {
    this.countdown = {
      createdAt: new Date(Date.now()).toISOString(),
      expiresAt: new Date(Date.now() + TIME_TO_CLOSE).toISOString(),
    }

    timer(TIME_TO_CLOSE)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.frameComponent.close()
      })
  }
}
